import axios from 'axios';

export const state = {
    overview: {}
};

export const mutations = {
    SET_OVERVIEW (state, newValue) {
        state.overview = newValue;
    },
    CLEAR (state) {
        state.overview = {};
    },
};

export const getters = {
    hasOverviewData (state) {
        return Object.keys(state.overview).length > 0;
    },
};

export const actions = {
    async getOverviewData({ commit }) {
        commit('loader/START_LOADING', null, { root: true });
        try{
            const { data } = await axios.get('/influencer/home');
            commit('SET_OVERVIEW', data);
        } finally {
            commit('loader/END_LOADING', null, { root: true });
        }
    }
};
